(() => {
  // Combine the gift guide's recommendations INTO the gift page's target grid.
  //
  // IMPORTANT: this must never install an always-on, document-wide observer.
  // The previous version observed document.documentElement with
  // {childList:true, subtree:true} and ran on EVERY DOM mutation across the
  // whole site (quick-buy opening, cart drawer re-render, lazy media, etc.).
  // That global churn is the only site-wide script the gift merge added and is
  // the most likely cause of upsell "cart mark does nothing" interference.
  //
  // Native cart / quick-buy / product-form code is untouched.

  // Do nothing at all unless THIS page actually renders the gift recommend grid.
  if (!document.querySelector('[data-gift-recommend-target] [data-gift-recommend-grid]')) return;

  const build = () => {
    const source = document.querySelector('recently-viewed-products[data-gift-recommend-source]');
    const grid = document.querySelector('[data-gift-recommend-target] [data-gift-recommend-grid]');
    if (!source || !grid || !source.querySelector('product-item')) return false;

    const template = document.createElement('template');
    template.innerHTML = source.innerHTML;
    const candidates = [...template.content.querySelectorAll('product-item')];
    const fallback = [...grid.children].map((card) => card.outerHTML);
    const chosen = [], seen = new Set();

    for (const item of candidates) {
      const key = item.querySelector('.product-item-meta__title')?.getAttribute('href')?.split('?')[0];
      if (!key || seen.has(key) || chosen.length === 3) continue;
      seen.add(key);
      chosen.push('<div class="bugs-recommend-products__item">' + item.outerHTML + '</div>');
    }
    for (const html of fallback) {
      const tmp = document.createElement('template'); tmp.innerHTML = html;
      const key = tmp.content.querySelector('.product-item-meta__title')?.getAttribute('href')?.split('?')[0];
      if (!key || seen.has(key) || chosen.length === 3) continue;
      seen.add(key); chosen.push(html);
    }

    // Remove the source before mounting, avoiding duplicate modal/form IDs.
    source.closest('.shopify-section')?.remove();
    if (source.isConnected) source.remove();
    grid.innerHTML = chosen.join('');
    return true;
  };

  // Try immediately; if the async "recently viewed" source has not populated yet,
  // watch ONLY until it is ready, then disconnect. Never left running.
  if (build()) return;

  const observer = new MutationObserver(() => { if (build()) observer.disconnect(); });
  observer.observe(document.body, { childList: true, subtree: true });
  // Hard stop so the observer can never linger.
  setTimeout(() => observer.disconnect(), 10000);
})();
